import { z } from 'zod'

export const HEX_COLOR = /^#[0-9a-fA-F]{6}(?![\s\S])/
export const EMAIL =
  /^(?=.{1,254}$)(?!.*[\p{Cc}\p{Cf}\p{Default_Ignorable_Code_Point}])[^\s@]+@[^\s@]+\.[^\s@]+$/u

// Control chars, zero-width, and BOM: invisible in an input, but they break
// CSS custom properties and URLs downstream.
const UNPRINTABLE = /\p{Cc}|\u200B|\u200C|\u200D|\uFEFF/u

export const isPrintable = (value: string) => !UNPRINTABLE.test(value)

export const isRelativeOrHttpsUrl = (value: string) =>
  ((value.startsWith('/') && !value.startsWith('//')) ||
    value.toLowerCase().startsWith('https://')) &&
  isPrintable(value)

export const hexColor = z
  .string()
  .regex(HEX_COLOR, 'Must be a 6-digit hex color like #1A2B3C')

export const email = z.string().regex(EMAIL, 'Enter a valid email address')

// One message covers scheme and printability: a zero-width char in a URL reads
// as a malformed URL, not as a separate character problem.
export const relativeOrHttpsUrl = z
  .string()
  .refine(isRelativeOrHttpsUrl, 'Must be a root-relative path or https:// URL')

export const requiredText = z
  .string()
  .refine((v) => v.trim().length > 0, 'Required')
  .refine(isPrintable, 'Must not contain control characters')

export const boundedText = (max: number) =>
  requiredText.refine(
    (v) => v.trim().length <= max,
    `At most ${max} characters`,
  )
